import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    noViolations: translate({ id: 'global.noViolations' }),
    orders: (count: number) => translate({ id: 'rm.summary.orders', values: { count } }),
  }))

  return api
}
